import CampaignIcon from "@mui/icons-material/Campaign";
import { BaseDetailModal } from "./BaseDetailModal";

export function AnnouncementModal(props) {
  return (
    <BaseDetailModal
      {...props}
      title="Announcement"
      sectionLabel="Announcement Message"
      icon={CampaignIcon}
      iconBgColor="bg-orange-50"
      iconColor="text-orange-600"
    />
  );
}